import { lazily } from 'react-lazily'
/**
 * Layouts
 */
import { SingleAction } from 'layout'
import Guard from 'guards/Guard'

const { RoleHelpDesk } = lazily(() => import('pages/home'))

const {
  ViewHelpDeskStudentDetail,
} = lazily(() => import('pages/students'))

/**
 * Layouts
 */
const LAYOUTS = {
  singleAction: SingleAction,
}

const basePath = '/dashboard/mesa-de-ayuda'

const helpDeskRoutes = [
  {
    name: 'role-mesadeayuda-home',
    path: basePath,
    homeForRole: ['Mesa de ayuda'], //change this after creating oraculo home
    element: RoleHelpDesk,
    guard: Guard,
    guardProps: { allowedRoles: ['Mesa de ayuda'] },
    suspenseFallback: null,
  },
  {
    name: 'mesa-de-ayuda-student-detail',
    path: basePath+'/:id',
    layoutProps: {title:"Datos del alumno/a",parentRouteName:"role-mesadeayuda-home"},
    element: ViewHelpDeskStudentDetail,
    layout: LAYOUTS.singleAction,
  },
]

export default helpDeskRoutes
